import { useState } from "react";

import { useParams } from "@tanstack/react-router";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useUrlFilterState } from "../../hooks/useUrlFilterState";
// State Import
import { useItemList } from "../../state/itemListState";
// Component imports
import { GenericListHeader } from "../../components/GenericHeader";
import { ItemTableFilterBar } from "../../components/ItemTableFilterBar";
import { ItemTable } from "../../components/ItemTable";

export function WardrobeItemList() {
  // Get wardrobe id from url param
  const { id } = useParams({ strict: false });

  // Wardrobe request filter state
  const [itemFilter, setItemFilter] = useUrlFilterState(
    {
      wardrobeID: id,
      search: "",
      page: 1,
      pageSize: 25,
    },
    { exclude: ["wardrobeID", "pageSize"] },
  );

  // Object to store the wardrobe state
  const [wardrobe, setWardrobe] = useState({
    filter: {},
    item: [],
    header: {},
    paging: {},
  });

  const { isPending, isError, data, error, isFetching, isSuccess } =
    useItemList(itemFilter);

  // Success Function
  const successFunc = () => setWardrobe(data.data.data.data.list);
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      <GenericListHeader heading={wardrobe?.header?.description} />
      <ItemTableFilterBar
        itemFilter={itemFilter}
        setItemFilter={setItemFilter}
      />
      {isError && <span>Error: {error.message}</span>}
      {wardrobe?.item?.length !== 0 ? (
        <ItemTable
          data={wardrobe}
          loading={isFetching}
          isWardrobe
          itemFilter={itemFilter}
          setItemFilter={setItemFilter}
        />
      ) : (
        !isPending && <p>No results</p>
      )}
    </>
  );
}
